/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// delegated handler for shipping checkbox changes

// function getCookie(name) {
//   const cookies = document.cookie.split('; ');
//   for (const cookie of cookies) {
//     const [key, value] = cookie.split('=');
//     if (key === name) {
//       return value;
//     }
//   }
//   return null; // Cookie not found
// }


$(document).on('change', '.if_mini_cart .ship_checkbox input[type="checkbox"]', function (e) {
  var $input = $(this);
  var $wrap  = $input.closest('.ship_checkbox, .switch'); // wrapper that may hold data-varid
  var isChecked = $input.prop('checked');

  // find variant id (search input first, then wrapper)
  var ship_pro_var = $input.attr('data-varid') || $input.data('varid') || ($wrap.length ? $wrap.data('varid') : null);
  if (!ship_pro_var) {
    console.warn('Missing data-varid for shipping product');
    // revert visual state just in case
    $input.prop('checked', !!isChecked);
    return;
  }

  // decide sections to request
  var tpl = (typeof window.template_name !== 'undefined' ? String(window.template_name) : '').trim();
  var sections_data = ['mini-cart'];
  if (tpl === 'flowyq-magicmind') sections_data = ['if_mini-cart'];

  // UI lock
  $input.prop('disabled', true);
  $wrap.addClass('c_loading');
  if ($wrap.find('.custom_loader').length === 0) $wrap.append('<div class="custom_loader"></div>');

  // helper to dispatch cart refresh
  function dispatchCartRefresh(cartData) {
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartData }, bubbles: true }));
    } catch (err) {
      console.error('dispatchCartRefresh error', err);
    }
  }

  // add variant
  function addVariant(variantId) {
    var payload = { quantity: 1, id: variantId, sections: sections_data };
    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(payload),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json'
    });
  }

  // remove variant by finding its line and calling change.js
  function removeVariantByVariantId(variantId) {
    return $.getJSON('/cart.js').then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) return $.Deferred().reject('invalid-cart');

      var idx = -1;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(variantId) || String(cart.items[i].id) === String(variantId)) {
          idx = i + 1; // shopify line is 1-based
          break;
        }
      }

      if (idx === -1) return $.Deferred().reject('variant-not-in-cart');

      var changeUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartChangeUrl)
        ? window.themeVariables.routes.cartChangeUrl + '.js'
        : '/cart/change.js';

      var payload = { line: idx, quantity: 0, sections: sections_data };

      return $.ajax({
        type: 'POST',
        url: changeUrl,
        data: JSON.stringify(payload),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      });
    });
  }

  // perform correct action based on checked state (no setTimeout, immediate)
  if (isChecked) {
    // add
    addVariant(ship_pro_var)
      .done(function (resp) {
        if (resp && resp.sections) {
          dispatchCartRefresh(resp);
        } else {
          $.getJSON('/cart.js').done(dispatchCartRefresh);
        }
      })
      .fail(function (err) {
        console.error('Failed to add shipping product:', err);
        // revert checkbox state on error
        $input.prop('checked', false);
        $('.warning').remove();
        var msg = 'Failed to add shipping protection.';
        try { if (err && err.responseJSON && err.responseJSON.description) msg = err.responseJSON.description; } catch (e) {}
        $wrap.after('<p class="warning">' + msg + '</p>');
      })
      .always(function () {
        $input.prop('disabled', false);
        $wrap.removeClass('c_loading').find('.custom_loader').remove();
      });
  } else {
    // remove
    removeVariantByVariantId(ship_pro_var)
      .done(function (resp) {
        if (resp && resp.sections) {
          dispatchCartRefresh(resp);
        } else {
          $.getJSON('/cart.js').done(dispatchCartRefresh);
        }
      })
      .fail(function (err) {
        // If variant-not-in-cart, treat as success (already removed)
        if (err === 'variant-not-in-cart' || (err && err.responseText && String(err.responseText).indexOf('variant-not-in-cart') !== -1)) {
          // make sure checkbox is unchecked and dispatch cart refresh to sync UI
          $input.prop('checked', false);
          $.getJSON('/cart.js').done(dispatchCartRefresh);
        } else {
          console.error('Failed to remove shipping product:', err);
          // revert checkbox state on error
          $input.prop('checked', true);
          $('.warning').remove();
          var msg = 'Failed to remove shipping protection.';
          try {
            if (typeof err === 'string') msg = err;
            else if (err && err.responseJSON && err.responseJSON.description) msg = err.responseJSON.description;
          } catch (e) {}
          $wrap.after('<p class="warning">' + msg + '</p>');
        }
      })
      .always(function () {
        $input.prop('disabled', false);
        $wrap.removeClass('c_loading').find('.custom_loader').remove();
      });
  }
});


$(document).on('change', '.sculpt_mini_cart .ship_checkbox input[type="checkbox"]', function (e) {
  var $input = $(this);
  var $wrap  = $input.closest('.ship_checkbox, .switch'); // wrapper that may hold data-varid
  var isChecked = $input.prop('checked');

  // find variant id (search input first, then wrapper)
  var ship_pro_var = $input.attr('data-varid') || $input.data('varid') || ($wrap.length ? $wrap.data('varid') : null);
  if (!ship_pro_var) {
    console.warn('Missing data-varid for shipping product');
    // revert visual state just in case
    $input.prop('checked', !!isChecked);
    return;
  }

  // decide sections to request
  var tpl = (typeof window.template_name !== 'undefined' ? String(window.template_name) : '').trim();
  var sections_data = ['mini-cart'];
  if (tpl == 'infinity-hoop') sections_data = ['sculpt_mini-cart'];

  // UI lock
  $input.prop('disabled', true);
  $wrap.addClass('c_loading');
  if ($wrap.find('.custom_loader').length === 0) $wrap.append('<div class="custom_loader"></div>');

  // helper to dispatch cart refresh
  function dispatchCartRefresh(cartData) {
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartData }, bubbles: true }));
    } catch (err) {
      console.error('dispatchCartRefresh error', err);
    }
  }

  // add variant
  function addVariant(variantId) {
    var payload = { quantity: 1, id: variantId, sections: sections_data };
    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(payload),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json'
    });
  }

  // remove variant by finding its line and calling change.js
  function removeVariantByVariantId(variantId) {
    return $.getJSON('/cart.js').then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) return $.Deferred().reject('invalid-cart');

      var idx = -1;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(variantId) || String(cart.items[i].id) === String(variantId)) {
          idx = i + 1; // shopify line is 1-based
          break;
        }
      }

      if (idx === -1) return $.Deferred().reject('variant-not-in-cart');

      var changeUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartChangeUrl)
        ? window.themeVariables.routes.cartChangeUrl + '.js'
        : '/cart/change.js';

      var payload = { line: idx, quantity: 0, sections: sections_data };

      return $.ajax({
        type: 'POST',
        url: changeUrl,
        data: JSON.stringify(payload),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      });
    });
  }

  // perform correct action based on checked state (no setTimeout, immediate)
  if (isChecked) {
    // add
    addVariant(ship_pro_var)
      .done(function (resp) {
        if (resp && resp.sections) {
          dispatchCartRefresh(resp);
        } else {
          $.getJSON('/cart.js').done(dispatchCartRefresh);
        }
      })
      .fail(function (err) {
        console.error('Failed to add shipping product:', err);
        // revert checkbox state on error
        $input.prop('checked', false);
        $('.warning').remove();
        var msg = 'Failed to add shipping protection.';
        try { if (err && err.responseJSON && err.responseJSON.description) msg = err.responseJSON.description; } catch (e) {}
        $wrap.after('<p class="warning">' + msg + '</p>');
      })
      .always(function () {
        $input.prop('disabled', false);
        $wrap.removeClass('c_loading').find('.custom_loader').remove();
      });
  } else {
    // remove
    removeVariantByVariantId(ship_pro_var)
      .done(function (resp) {
        if (resp && resp.sections) {
          dispatchCartRefresh(resp);
        } else {
          $.getJSON('/cart.js').done(dispatchCartRefresh);
        }
      })
      .fail(function (err) {
        // If variant-not-in-cart, treat as success (already removed)
        if (err === 'variant-not-in-cart' || (err && err.responseText && String(err.responseText).indexOf('variant-not-in-cart') !== -1)) {
          // make sure checkbox is unchecked and dispatch cart refresh to sync UI
          $input.prop('checked', false);
          $.getJSON('/cart.js').done(dispatchCartRefresh);
        } else {
          console.error('Failed to remove shipping product:', err);
          // revert checkbox state on error
          $input.prop('checked', true);
          $('.warning').remove();
          var msg = 'Failed to remove shipping protection.';
          try {
            if (typeof err === 'string') msg = err;
            else if (err && err.responseJSON && err.responseJSON.description) msg = err.responseJSON.description;
          } catch (e) {}
          $wrap.after('<p class="warning">' + msg + '</p>');
        }
      })
      .always(function () {
        $input.prop('disabled', false);
        $wrap.removeClass('c_loading').find('.custom_loader').remove();
      });
  }
});


document.addEventListener('cart:updated', function(event) {
  const cart = event.detail.cart;

  if (cart.items.length === 1) {
    const item = cart.items[0];

    if (item.handle == 'package-protection-sustainability' || item.title.toLowerCase().includes('package-protection')) {
      
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
         bubbles: true
       }));
      })
      .catch(err => console.error('Error clearing cart:', err));
    }
  }
});


// function freeShipping() {
//   var shippingAvailable = false;
//   var shippingEligible = false;
  
//   var $switch = $('.ship_checkbox .switch');

//   var shipping_product_id = $switch.data('varid');
//   $.ajax({
//     type: 'GET',
//     url: '/cart.json',
//     dataType: 'json',
//     success: function (data) {
//       const shippingProtection = getCookie('shipping_protection');
//       var items = data.items;
//       console.log(items);

//       for (var i = 0; i < items.length; i++) {
//         if (items[i]['id'] == shipping_product_id) {
//           shippingAvailable = true;
//           break;
//         }
//       }

//       if (shippingAvailable == false && shippingProtection != 'hide') {
//         $('.ship_checkbox input').prop('checked', true);
//       }

//       if (shippingAvailable == true && items.length == 1) {
//         $('.ship_checkbox input').prop('checked', false);
//       }

//       if ($('.ship_checkbox input').is(':checked')) {
//         shippingEligible = true;
//       } else {
//         shippingEligible = false;
//       }

//       console.log('shippingEligible', shippingEligible);
//       console.log('shippingAvailable', shippingAvailable);

//       if (shippingEligible == true && shippingAvailable == false) {
//         addShippingProtection(shipping_product_id);
        
      

//       } else if (shippingEligible == false && shippingAvailable == true) {
//         removeShippingProtection(shippingProtection, shipping_product_id, items);
        
//       }
//     },
//     error: function () {
//       console.log('Cannot get cart data');
//     },
//   });
// }

// function addShippingProtection(shipping_product_id) {

//   if (!shipping_product_id) {
//     console.error("Shipping product variant ID is missing!");
//     return;
//   }

//   var tpl = (typeof window.template_name !== 'undefined' ? String(window.template_name) : '').trim();
//   var sections_data = ['mini-cart'];
//   if (tpl == 'infinity-hoop') sections_data = ['sculpt_mini-cart'];

//   $.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     dataType: 'json',
//     data: JSON.stringify({
//       id: Number(shipping_product_id),   // ✅ ensure number
//       quantity: 1,                       // ❗ MUST include quantity
//       sections: sections_data,
//       sections_url: window.location.pathname,
//     }),
//     contentType: 'application/json',

//     success: function (resp) {

//       document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
//         bubbles: true,
//         detail: { cart: resp }
//       }));

//       document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
//         bubbles: true,
//         detail: {
//           cart: resp,
//           openMiniCart: true
//         }
//       }));

//       document.cookie = 'shipping_protection=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//     },

//     error: function (err) {
//       console.error('Error adding shipping protection:', err);
//     }
//   });
// }




// function removeShippingProtection(shippingProtection, shipping_product_id, items) {
//   if (!shipping_product_id) {
//     console.error("Shipping product variant ID is missing!");
//     return;
//   }

//   // Convert ID to string (safe + guaranteed)
//   shipping_product_id = String(shipping_product_id);

//   var tpl = (typeof window.template_name !== 'undefined' ? String(window.template_name) : '').trim();
//   var sections_data = ['mini-cart'];
//   if (tpl == 'infinity-hoop') sections_data = ['sculpt_mini-cart'];

//   $.ajax({
//     type: 'POST',
//     url: '/cart/change.js',
//     dataType: 'json',
//     data: JSON.stringify({
//       id: shipping_product_id,     // ✅ STRING ONLY
//       quantity: 0,
//       sections: sections_data,
//       sections_url: window.location.pathname,
//     }),
//     contentType: 'application/json',

//     success: function (cart) {

//       if (shippingProtection != 'hide') {
//         document.cookie = 'shipping_protection=hide';
//       }

//       $.ajax({
//         type: 'GET',
//         url: '/cart.json',
//         dataType: 'json',
//         success: function (data) {
//           var items = data.items;

//           if (items.length < 1) {
//             document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
//               bubbles: true,
//               detail: { cart: data }
//             }));

//             document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
//               bubbles: true,
//               detail: {
//                 cart: data,
//                 openMiniCart: true
//               }
//             }));

//             document.cookie = 'shipping_protection=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//           }
//         }
//       });
//     },

//     error: function (err) {
//       console.log('Error removing shipping protection:', err);
//     }
//   });
// }



// // Remove line Item Progress Bar (no early guard — user requested it removed)
// $(document).on('click', '.if_mini_cart [data-liniitemremove-btn]', function (e) {
//   var temp_removeBtn = $(this);
//   var mainprent = temp_removeBtn.closest('.line-item');
//   mainprent.addClass('removing');
//   var timer = setTimeout(function () {
//     mainprent.removeClass('removing');
//   }, 5000);
// });
// // [data-undoBtn]
// $(document).on('click', '.if_mini_cart [data-undoBtn]', function (e) {
//   var undoBtn = $(this);
//   var mainprent = undoBtn.closest('.line-item');
//   mainprent.removeClass('removing');
// });
// // [data-confirmBtn]
// $(document).on('click', '.if_mini_cart [data-confirmBtn]', function (e) {
//   var confirmBtn = $(this);
//   var mainprent = confirmBtn.closest('.line-item');
//   mainprent.removeClass('removing');
// });

// helper: get nearest Element node from an event target (handles text nodes)
function getElementFromEventTarget(node) {
  while (node && node.nodeType !== Node.ELEMENT_NODE) {
    node = node.parentNode;
  }
  return node;
}
// Remove line Item Progress Bar (no extra logic, same as original)
document.addEventListener('click', function (e) {
  var el = getElementFromEventTarget(e.target);
  if (!el) return;
  var temp_removeBtn = el.closest('[data-liniitemremove-btn]');
  if (temp_removeBtn && temp_removeBtn.closest('.if_mini_cart')) {
    var mainprent = temp_removeBtn.closest('.line-item');
    if (mainprent) {
      mainprent.classList.add('removing');
      var timer = setTimeout(function () {
        mainprent.classList.remove('removing');
      }, 5000);
    }
  }
});
// [data-undoBtn]
document.addEventListener('click', function (e) {
  var el = getElementFromEventTarget(e.target);
  if (!el) return;
  var undoBtn = el.closest('[data-undoBtn]');
  if (undoBtn && undoBtn.closest('.if_mini_cart')) {
    var mainprent = undoBtn.closest('.line-item');
    if (mainprent) {
      mainprent.classList.remove('removing');
    }
  }
});
// [data-confirmBtn]
document.addEventListener('click', function (e) {
  var el = getElementFromEventTarget(e.target);
  if (!el) return;
  var confirmBtn = el.closest('[data-confirmBtn]');
  if (confirmBtn && confirmBtn.closest('.if_mini_cart')) {
    var mainprent = confirmBtn.closest('.line-item');
    if (mainprent) {
      mainprent.classList.remove('removing');
    }
  }
});


document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('.custom-shopify-product-form');
  const variantDataList = document.querySelectorAll('.variants_data li');
  const variantInput = productForm?.querySelector('input[name="id"]');
  const sellingPlanInputName = 'selling_plan';

  function formatMoney(cents) {
    const price = (cents / 100).toFixed(2);
    return `${price} ฿`;
  }

  function getVariantData(variantId) {
    return Array.from(variantDataList).find(li => li.dataset.vid === variantId.toString());
  }

function updateDisplayedPrices(variantId) {
  const data = getVariantData(variantId);
  if (!data) return;

  const price = formatMoney(data.dataset.price);
  const compare = formatMoney(data.dataset.comprice);
  const subPrice = formatMoney(data.dataset.subprice);

  const subBox = document.querySelector('.subscription-box.active');
  const subPriceElem = subBox?.querySelector('.subscription-price .discounted-price');
  const subCompareElem = subBox?.querySelector('.subscription-price .compare-price');
  const onceBox = document.querySelector('.buy-once-box');
  const oncePriceElem = onceBox?.querySelector('.buy-once-price');

  if (subPriceElem) subPriceElem.textContent = subPrice;

  if (subCompareElem) {
    if (data.dataset.subprice !== data.dataset.comprice) {
      subCompareElem.style.display = 'inline';
      subCompareElem.textContent = compare;
    } else {
      subCompareElem.style.display = 'none';
    }
  }

  if (oncePriceElem) oncePriceElem.textContent = price;

  setTimeout(() => {
    const addToCartBtn = document.querySelector('#AddToCart .loader-button__text');

    if (addToCartBtn) {
      if (document.querySelector('.subscription-box.active')) {
        addToCartBtn.textContent = `Add to cart for ${subPrice}`;
      } else {
        addToCartBtn.textContent = 'Try Magic Mind';
      }
    }
  }, 10); 
}



  function handlePlanSelection(selectedBox) {
    const subscriptionBoxes = document.querySelectorAll('.subscription-box-card');
    subscriptionBoxes.forEach(box => box.classList.remove('active'));
    selectedBox.classList.add('active');

    const selectedPlan = selectedBox.querySelector('input[name="purchase_option"]').dataset.plan;
    const activeVariantId = variantInput?.value;
    const activeVariantData = getVariantData(activeVariantId);

    const existingSellingPlanInput = productForm.querySelector(`input[name="${sellingPlanInputName}"]`);
    if (existingSellingPlanInput) existingSellingPlanInput.remove();

    if (selectedPlan === 'autoship' && activeVariantData) {
      const spId = activeVariantData.dataset.sellingPlanId;
      if (spId) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = sellingPlanInputName;
        input.value = spId;
        productForm.appendChild(input);
      }
    }

    updateDisplayedPrices(activeVariantId);
  }

  function bindSubscriptionEvents() {
    const subscriptionBoxes = document.querySelectorAll('.subscription-box-card');
    subscriptionBoxes.forEach(box => {
      const radio = box.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.addEventListener('change', () => handlePlanSelection(box));
    });
  }

  const observer = new MutationObserver(() => {
    bindSubscriptionEvents();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('variant:changed', event => {
    const variant = event.detail.variant;
    if (variant?.id) updateDisplayedPrices(variant.id.toString());
  });

  bindSubscriptionEvents();

  const initialActive = document.querySelector('.subscription-box-card.active');
  if (initialActive) handlePlanSelection(initialActive);
});



$(document).ready(function() {

 $(".popup-with-zoom-anima").magnificPopup({
    type: "inline",

    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: "auto",

    closeBtnInside: true,
    preloader: false,

    midClick: true,
    removalDelay: 300,
    mainClass: "my-mfp-zoom-in",
  });
});


// document.querySelectorAll('.choose-color .block-swatch__radio').forEach(radio => {
//   radio.addEventListener('change', () => {
//     setTimeout(() => {

//       const activeThumb = document.querySelector('.product__thumbnail-item[aria-current="true"] img');
//       if (!activeThumb) return;

//       const activeSrc = activeThumb.getAttribute('src');

//       const firstThumb = document.querySelector('.product__thumbnail-item img');

//       if (firstThumb) {
//         firstThumb.setAttribute('src', activeSrc);
//       }

//     }, 400);
//   });
// });
